// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnsupportedMessagePayload__container-a45790 {
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/UnsupportedMessagePayload/UnsupportedMessagePayload.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF","sourcesContent":[".container {\n  color: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UnsupportedMessagePayload__container-a45790`
};
module.exports = ___CSS_LOADER_EXPORT___;
